import { map } from 'lodash'
import { forwardRef, useMemo } from 'react'
import { graphql, useFragment } from 'react-relay'

import { type EducationLevelsMultiSelectInput_query$key } from '@/__generated__/EducationLevelsMultiSelectInput_query.graphql'
import { MultiSelectInput, type MultiSelectInputProps, type MultiSelectInputRef, type SelectOption } from '@/components'

export type EducationLevelsMultiSelectInputProps = Omit<MultiSelectInputProps, 'options'> & {
  queryRef: EducationLevelsMultiSelectInput_query$key | null | undefined
}

export const EducationLevelsMultiSelectInput = forwardRef<MultiSelectInputRef, EducationLevelsMultiSelectInputProps>(
  ({ queryRef, ...props }, ref) => {
    const queryData = useFragment(
      graphql`
        fragment EducationLevelsMultiSelectInput_query on Query {
          educationLevels(orderBy: [SEQUENCE_ASC]) {
            nodes {
              name
              rowId
            }
          }
        }
      `,
      queryRef
    )

    return (
      <MultiSelectInput
        options={useMemo<SelectOption[]>(
          () =>
            map(queryData?.educationLevels?.nodes, (educationLevel) => ({
              label: educationLevel!.name,
              value: educationLevel!.rowId
            })),
          [queryData?.educationLevels?.nodes]
        )}
        ref={ref}
        {...props}
      />
    )
  }
)

EducationLevelsMultiSelectInput.displayName = 'EducationLevelsMultiSelectInput'
